// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UkEjHbqcWDNc3Jll1Azy {
    width: 100%;
    position: sticky;
    display: flex;
    flex-direction: column;
    top: 0;
    left: auto;
    right: 0;
    background-color: white;
    min-height: var(--header-height);
    max-height: var(--header-height);
}

.aULVYbZNt_rPlzT3myaG {
    width: 100%;
    padding: 0 24px;
    display: flex;
    gap: 8px;
    align-items: center;
    flex: 1;

    & .z4VJ3cBMqdFAoB5CWjGc {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}

.qGYuxgnrRcp0rg1R4YL0 {
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
    font: inherit;
    text-align: left;
    color: inherit;
}

@container (max-width: 200px) {
    .z4VJ3cBMqdFAoB5CWjGc {
        display: none;
    }
}

.By7p4g5_zUGXWaJLBuRn {
    max-width: 240px;
    max-height: 80px;
    display: block;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Layout/Header/Header.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,UAAU;IACV,QAAQ;IACR,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,OAAO;;IAEP;QACI,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".header {\n    width: 100%;\n    position: sticky;\n    display: flex;\n    flex-direction: column;\n    top: 0;\n    left: auto;\n    right: 0;\n    background-color: white;\n    min-height: var(--header-height);\n    max-height: var(--header-height);\n}\n\n.headerContent {\n    width: 100%;\n    padding: 0 24px;\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    flex: 1;\n\n    & .headerTitle {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n    }\n}\n\n.clickable {\n    cursor: pointer;\n    border: none;\n    background: none;\n    padding: 0;\n    font: inherit;\n    text-align: left;\n    color: inherit;\n}\n\n@container (max-width: 200px) {\n    .headerTitle {\n        display: none;\n    }\n}\n\n.image {\n    max-width: 240px;\n    max-height: 80px;\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `UkEjHbqcWDNc3Jll1Azy`,
	"headerContent": `aULVYbZNt_rPlzT3myaG`,
	"headerTitle": `z4VJ3cBMqdFAoB5CWjGc`,
	"clickable": `qGYuxgnrRcp0rg1R4YL0`,
	"image": `By7p4g5_zUGXWaJLBuRn`
};
export default ___CSS_LOADER_EXPORT___;
